import { Nullable } from 'cng-common/models/utils'

interface IParams {
  actuals: Nullable<number>
  sobActuals: Nullable<number>
}

export const calculateTam = ({ actuals, sobActuals }: IParams) => {
  if (!actuals || !sobActuals) {
    return null
  }

  return actuals / (sobActuals / 100)
}
